<template>
  <div>
    <card-toolbar
      icon="account_circle"
      :title="$tc('user_profile')"
    />

    <v-tabs
      show-arrows
      :ripple="false"
      v-model="active"
      slider-color="dinamo"
      background-color="transparent"
      centered
      class="mb-2"
    >
      <!-- Tabs -->
      <template v-for="(tab, key) in tabs">
        <v-tab :id="`tab-${tab}`" ripple :key="`tab-${key}`">
          {{ $tc(tab) }}
        </v-tab>
      </template>
    </v-tabs>

    <v-card flat class="rounded-lg pa-0" outlined style="background: transparent;">
      <div class="pa-1">
        <v-tabs-items v-model="active">
          <v-tab-item>
            <tab-attributes />
          </v-tab-item>

          <v-tab-item>
            <tab-permissions />
          </v-tab-item>

          <v-tab-item>
            <tab-change-password />
          </v-tab-item>
        </v-tabs-items>
      </div>
    </v-card>
  </div>
</template>

<script>
import TabAttributes from './tabs/TabAttributes'
import TabChangePassword from './tabs/TabChangePassword'
import TabPermissions from './tabs/TabPermissions'
import CardToolbar from '@/components/CardToolbar'

export default {
  components: {
    TabAttributes,
    TabChangePassword,
    TabPermissions,
    CardToolbar
  },
  created () {
    this.setTab()
  },
  data () {
    return {
      active: null
    }
  },
  computed: {
    tabs () {
      return [
        'attributes',
        'system_permission',
        'change_password'
      ]
    }
  },
  methods: {
    setTab () {
      const query = this.$route.query

      if (query.tab) {
        switch (query.tab) {
          case 'attributes':
            this.active = 0
            break
          case 'permissions':
            this.active = 1
            break
          case 'change-password':
            this.active = 2
            break
          default:
            this.active = 0
            break
        }
      }
    }
  },
  watch: {
    $route () {
      this.setTab()
    },
    active (val) {
      switch (val) {
        case 0:
          this.$router.push({ query: { tab: 'attributes' } })
          break
        case 1:
          this.$router.push({ query: { tab: 'permissions' } })
          break
        case 2:
          this.$router.push({ query: { tab: 'change-password' } })
          break
        default:
          this.$router.push({ query: { tab: 'attributes' } })
          break
      }
    }
  }
}
</script>
